import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllCurricularUnitsUserUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllCurricularUnitsUser
  implements GetAllCurricularUnitsUserUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllCurricularUnitsUserUseCaseInterface.Result>,
  ) {}

  async execute(
    params?: GetAllCurricularUnitsUserUseCaseInterface.Params,
  ): Promise<GetAllCurricularUnitsUserUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        entity: params?.entityId,
        course: params?.courseId,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
